webpackJsonp([42968260613350],{

/***/ 1742:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Container = __webpack_require__(5);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _SEO = __webpack_require__(6);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _Logo = __webpack_require__(26);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _Hr = __webpack_require__(45);
	
	var _Hr2 = _interopRequireDefault(_Hr);
	
	var _WistiaVideo = __webpack_require__(53);
	
	var _WistiaVideo2 = _interopRequireDefault(_WistiaVideo);
	
	var _Chat = __webpack_require__(39);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _QuestionAnswer = __webpack_require__(36);
	
	var _QuestionAnswer2 = _interopRequireDefault(_QuestionAnswer);
	
	var _ViewCarousel = __webpack_require__(37);
	
	var _ViewCarousel2 = _interopRequireDefault(_ViewCarousel);
	
	var _PlayCircleFilled = __webpack_require__(35);
	
	var _PlayCircleFilled2 = _interopRequireDefault(_PlayCircleFilled);
	
	var _LiveTv = __webpack_require__(1184);
	
	var _LiveTv2 = _interopRequireDefault(_LiveTv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Upgrade = function Upgrade(_ref) {
	  var classes = _ref.classes;
	
	  return _react2.default.createElement(
	    "div",
	    { className: classes.root },
	    _react2.default.createElement(_SEO2.default, null),
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: classes.top, style: { textAlign: "center" } },
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              padding: "25px",
	              backgroundColor: "#f159535e",
	              marginBottom: "30px",
	              lineHeight: "2em"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                fontWeight: "700",
	                width: "100%",
	                textAlign: "center",
	                fontSize: "24px",
	                paddingBottom: "10px"
	              }
	            },
	            "IMPORTANT ANNOUNCEMENT FOR LISTINGBOOK AGENTS"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { textAlign: "center" } },
	            "Excluding Triad MLS, ALL Listingbook agents & their clients have now been upgraded to Elevate. You can NO LONGER log in at Listingbook.com. Please follow login instruction for your NEW Elevate account",
	            _react2.default.createElement("br", null),
	            "via email / text communication and/or your Elevate morning report.",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "a",
	              {
	                target: "_blank",
	                href: "https://support.tryelevate.com/s/ /articles/360018375372-Listingbook-to-Elevate-FAQs#help-login",
	                className: classes.getStartedLink2
	              },
	              "Login to Elevate"
	            ),
	            "\xA0\xA0",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "",
	                onClick: function onClick(e) {
	                  e.preventDefault();
	                  if (window.zE) window.zE.activate();
	                },
	                className: classes.getStartedLink2
	              },
	              "Chat with Coach"
	            )
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "div",
	            { className: classes.bold },
	            "TRIAD MLS USERS ONLY, click the link below:"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { paddingTop: "25px", paddingBottom: "25px" } },
	            _react2.default.createElement(
	              "a",
	              {
	                target: "_blank",
	                href: "https://triadlistingbook.com/home",
	                className: classes.getStartedLink2
	              },
	              "Triad Users Login"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: classes.centerHeading },
	          _react2.default.createElement(
	            "div",
	            { style: { textAlign: "center", fontSize: "12px" } },
	            "Migrated MLSes: SMART, TAR, BAREIS, MRED, SANDICOR, CARETS, Wilmington, SABOR, JSMLS, ARMLS,",
	            _react2.default.createElement("br", null),
	            "MARISMO, MIREAL, SWFLAMLS, NEFMLS, SEFMLAMLS, MRIS, Orlando, LIBOR, CRMLS, HGAR."
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.heading, style: { paddingTop: "45px" } },
	            "New to Elevate?"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.bold },
	            "Here\u2019s everything you need to know about your upgrade to Elevate."
	          ),
	          _react2.default.createElement("br", null)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: classes.top },
	        _react2.default.createElement(
	          "div",
	          { className: classes.column, style: {} },
	          _react2.default.createElement(
	            "div",
	            { className: classes.grayText, style: { textAlign: "center" } },
	            _react2.default.createElement(
	              "div",
	              { className: classes.heading },
	              "Getting Started Videos"
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              "Explore everything that is Elevate with these",
	              " ",
	              _react2.default.createElement(
	                "span",
	                { className: classes.bold },
	                " easy-to-digest videos "
	              ),
	              "designed to introduce you to all of the new features & functionality that you and your clients will LOVE."
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { paddingTop: "30px" } },
	              _react2.default.createElement(
	                "a",
	                {
	                  target: "_blank",
	                  href: "https://tryelevate.wistia.com/projects/ibbj6zglui",
	                  className: classes.darkTealLink,
	                  style: { backgroundColor: "#3e928b" }
	                },
	                _react2.default.createElement(_LiveTv2.default, {
	                  color: "#FFFFFF",
	                  size: 30,
	                  className: classes.iconPosition,
	                  style: { top: "8px", right: "6px" }
	                }),
	                "Watch Now"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_Hr2.default, { style: { marginTop: "40px", marginBottom: "40px" } })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { textAlign: "center" } },
	            _react2.default.createElement(
	              "div",
	              { className: classes.heading },
	              "FAQ for You"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { paddingBottom: "30px" } },
	              "Here are quick answers to your most important questions about Elevate and your client\u2019s information."
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  target: "_blank",
	                  href: "https://support.tryelevate.com/s/ /articles/360018375372-Listingbook-to-Elevate-FAQs",
	                  className: classes.getStartedLink
	                },
	                _react2.default.createElement(_QuestionAnswer2.default, {
	                  color: "#FFFFFF",
	                  size: 28,
	                  className: classes.iconPosition,
	                  style: { top: "9px", right: "5px" }
	                }),
	                " ",
	                "View FAQ"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: classes.column },
	          _react2.default.createElement(
	            "div",
	            { className: classes.infoboxTeal },
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "div",
	                { className: classes.heading, style: { color: "#FFFFFF" } },
	                "Training Webinars"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { paddingTop: "10px" } },
	              _react2.default.createElement("span", { className: classes.bold, style: { color: "#FFFFFF" } })
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { paddingTop: "30px" } },
	              _react2.default.createElement(
	                "a",
	                {
	                  target: "_blank",
	                  href: "https://tryelevate.wistia.com/projects/ibbj6zglui",
	                  className: classes.darkTealLink,
	                  style: { backgroundColor: "#3e928b" }
	                },
	                "On Demand Recordings"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { textAlign: "center" } },
	            _react2.default.createElement(
	              "div",
	              { className: classes.heading },
	              "FAQ for Your Clients"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { paddingBottom: "30px" } },
	              "We\u2019ve created a special FAQ experiences",
	              _react2.default.createElement("br", null),
	              "for you to share with your clients.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                { className: classes.bold },
	                "Just share the link below..."
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  target: "_blank",
	                  href: "https://support.tryelevate.com/s/ /sections/360003180791-Listingbook-to-Elevate-Upgrade-for-Clients",
	                  className: classes.getStartedLink
	                },
	                _react2.default.createElement(_QuestionAnswer2.default, {
	                  color: "#FFFFFF",
	                  size: 28,
	                  className: classes.iconPosition,
	                  style: { top: "9px", right: "5px" }
	                }),
	                " ",
	                "View Client FAQ"
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null)
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: classes.infoboxGray },
	        _react2.default.createElement(
	          "div",
	          { style: { textAlign: "center" } },
	          _react2.default.createElement(
	            "div",
	            { className: classes.heading },
	            "Chat with us NOW"
	          ),
	          "The Elevate Success Team is here to help you every step of the way.",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "div",
	            { className: classes.bold },
	            "How can we help you today?"
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "a",
	            {
	              href: "",
	              className: classes.getStartedLink,
	              onClick: function onClick(e) {
	                e.preventDefault();
	                if (window.zE) window.zE.activate();
	              }
	            },
	            _react2.default.createElement(_Chat2.default, {
	              color: "#FFFFFF",
	              size: 28,
	              className: classes.iconPosition,
	              style: { top: "10px" }
	            }),
	            " ",
	            "Chat with Success Coach"
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    root: {
	      position: "relative",
	      paddingTop: "96px",
	      paddingBottom: "102px",
	      lineHeight: "1.75em"
	    },
	    top: {
	      display: "flex",
	      flexWrap: "wrap",
	      alignItems: "center"
	    },
	    section: {
	      paddingTop: "60px"
	    },
	    heading: {
	      color: theme.colors.secondary,
	      fontSize: "32px",
	      fontWeight: "700",
	      marginRight: "auto",
	      paddingBottom: "20px"
	    },
	    centerHeading: {
	      alignItems: "center",
	      width: "100%",
	      textAlign: "center"
	    },
	    bold: {
	      fontWeight: "700"
	    },
	    column: {
	      width: "530px",
	      maxWidth: "100%",
	      paddingRight: "10px",
	      paddingLeft: "10px",
	      verticalAlign: "top"
	    },
	    getStartedLink: {
	      width: "250px",
	      alignContent: "center",
	      justifyContent: "center",
	      fontSize: "14px",
	      fontWeight: "700",
	      letterSpacing: ".25px",
	      backgroundColor: theme.colors.secondary,
	      color: "#FFF",
	      textDecoration: "none",
	      padding: "14px 16px",
	      borderRadius: "4px",
	      margin: "16px auto"
	    },
	    getStartedLink2: {
	      width: "250px",
	      alignContent: "center",
	      justifyContent: "center",
	      fontSize: "14px",
	      fontWeight: "700",
	      letterSpacing: ".25px",
	      backgroundColor: "#FFF",
	      color: "#f15953",
	      textDecoration: "none",
	      padding: "14px 16px",
	      borderRadius: "4px",
	      margin: "16px auto"
	    },
	    darkTealLink: {
	      width: "250px",
	      alignContent: "center",
	      justifyContent: "center",
	      fontSize: "14px",
	      fontWeight: "700",
	      letterSpacing: ".25px",
	      backgroundColor: theme.colors.secondaryDark,
	      color: "#FFF",
	      textDecoration: "none",
	      padding: "14px 16px",
	      borderRadius: "4px",
	      margin: "16px auto"
	    },
	    grayLink: {
	      width: "250px",
	      alignContent: "center",
	      justifyContent: "center",
	      fontSize: "14px",
	      fontWeight: "700",
	      letterSpacing: ".25px",
	      backgroundColor: theme.colors.gray400,
	      color: "#FFF",
	      textDecoration: "none",
	      padding: "14px 16px",
	      borderRadius: "4px",
	      margin: "16px auto"
	    },
	    grayText: {
	      color: theme.colors.gray800
	    },
	    infoboxGray: {
	      alignContent: "center",
	      justifyContent: "center",
	      backgroundColor: theme.colors.gray100,
	      color: theme.colors.gray800,
	      textDecoration: "none",
	      padding: "40px 10px",
	      borderRadius: "4px",
	      margin: "30px auto",
	      textAlign: "center"
	    },
	    infoboxTeal: {
	      alignContent: "center",
	      justifyContent: "center",
	      backgroundColor: theme.colors.secondary,
	      color: theme.colors.gray800,
	      textDecoration: "none",
	      padding: "40px 10px",
	      borderRadius: "4px",
	      margin: "30px auto",
	      textAlign: "center"
	    },
	    videoBorder: {
	      borderStyle: "solid",
	      borderWidth: "1px",
	      borderColor: theme.colors.gray400
	    },
	    iconPosition: {
	      position: "relative",
	      top: "12px",
	      right: "4px"
	    }
	  };
	})(Upgrade);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-upgrade-js-dc2b95aa12e6f4879448.js